// NAIZOR — precios en francés de Quebec: «47,10 $» en lugar de «$47.10» (solo en las páginas en francés).
// El formato de moneda de Shopify es único para toda la tienda; aquí se reescribe el texto visible. Los pagos y el checkout no se tocan
// (el checkout de Shopify ya usa el formato de cada idioma).
(function () {
  var lang = (document.documentElement.lang || '').toLowerCase();
  if (lang.indexOf('fr') !== 0) return;
  var suffix = (window.Shopify && window.Shopify.country === 'US') ? ' $ US' : ' $';
  var RE = /(^|[^\w$])\$\s?(\d{1,3}(?:,\d{3})+|\d+)(?:\.(\d{1,2}))?(?![\d])/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, CODE: 1 };
  var done = new WeakMap();

  function convert(s) {
    return s.replace(RE, function (m, pre, whole, dec) {
      var w = whole.replace(/,/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      return pre + w + (dec ? ',' + (dec.length === 1 ? dec + '0' : dec) : '') + suffix;
    });
  }
  function fix(node) {
    if (node.nodeType === 3) {
      var p = node.parentNode;
      if (!p || SKIP[p.nodeName]) return;
      var v = node.nodeValue;
      if (done.get(node) === v || v.indexOf('$') === -1) return;
      var out = convert(v);
      if (out !== v) { node.nodeValue = out; done.set(node, out); }
    } else if (node.nodeType === 1 && !SKIP[node.nodeName]) {
      var w = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      var n; while ((n = w.nextNode())) fix(n);
    }
  }
  var queue = [], scheduled = false;
  function flush() { scheduled = false; var q = queue; queue = []; q.forEach(fix); }
  function add(n) { queue.push(n); if (!scheduled) { scheduled = true; requestAnimationFrame(flush); } }

  function start() {
    fix(document.body);
    new MutationObserver(function (list) {
      list.forEach(function (m) {
        if (m.type === 'characterData') add(m.target);
        else m.addedNodes.forEach(add);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
